import { Component, Prop, Vue } from 'vue-property-decorator';
import { imageData } from '@/helpers/ImageHelpers';
import { stripTrustedHTML, toKebabCase } from '@/helpers/StringHelpers';
import Subtitle from '@/components/elements/Subtitle.vue';
@Component({
    name: 'EventListingItem',
    components: { Subtitle },
})
export default class default_1 extends Vue {
    @Prop()
    event;
    @Prop()
    path;
    get image() {
        return imageData(this.event, 'teaser');
    }
    get categoryClass() {
        if (!this.event?.category) {
            return undefined;
        }
        const category = stripTrustedHTML(this.event.category);
        return `category-${toKebabCase(category)}`;
    }
    get linkTitle() {
        return this.$t('linkTitle', { name: stripTrustedHTML(this.event.name) });
    }
}
